/* eslint-disable camelcase, react/jsx-pascal-case */ import { jsx as _jsx } from "react/jsx-runtime";
import { Unstable_ActionHrefAdapterContext } from '@sail/ui';
import * as React from 'react';
import useActionHrefAdapter from '../../internal/useActionHrefAdapter';
export default function NavigationUiProvider({ children }) {
    return /*#__PURE__*/ _jsx(Unstable_ActionHrefAdapterContext.Provider, {
        value: useActionHrefAdapter,
        children: children
    });
}

//# sourceMappingURL=NavigationUiProvider.js.map